import { CREATE_PAYMENT_INTENT } from '../../constants/endpoints';

export const RECEIVE_PAYMENT_RESPONSE = 'SERVICE_FEE/RECEIVE_PAYMENT_RESPONSE';
export const RECEIVE_PAYMENT_COMPLETE = 'SERVICE_FEE/RECEIVE_PAYMENT_COMPLETE';
export const RECEIVE_FEE = 'SERVICE_FEE/RECEIVE_FEE';
export const RECEIVE_ERROR = 'SERVICE_FEE/RECEIVE_ERROR';
export const CONFIGURE_STRIPE_WIDGET = 'CONFIGURE_STRIPE_WIDGET';

export const receivePaymentResponse = ({
  service,
  paymentIntentSecret,
  narvarPaymentId,
  publishableKey,
  transactionDescription,
}) => ({
  type: RECEIVE_PAYMENT_RESPONSE,
  data: {
    service,
    paymentIntentSecret,
    narvarPaymentId,
    publishableKey,
    transactionDescription,
  },
});

export const receivePaymentComplete = (completedPayment) => (dispatch) => {
  dispatch({
    type: RECEIVE_PAYMENT_COMPLETE,
    data: {
      completedPayment,
    },
  });
};

export const receiveError = (errorMessage) => (dispatch) => {
  dispatch({
    type: RECEIVE_ERROR,
    data: {
      errorMessage,
    },
  });
};

export const fetchPaymentIntent = (service) => async (dispatch, getState) => {
  const {
    orderInfo: {
      currentOrderNumber,
      orderData: { order_info: { retailer_moniker: retailerMoniker } = {} } = {},
    } = {},
    retailerSettings: { name },
    landingPage: { landingForm: { email } = {} } = {},
    page: { locale = '' } = {},
  } = getState();
  try {
    const fetchOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        payment: {
          customer_email: email,
          retailer_moniker: retailerMoniker || name,
          order_number: currentOrderNumber,
          service,
          locale,
        },
      }),
    };
    // todo figure out where mapping should exist
    const response = await fetch(`${CREATE_PAYMENT_INTENT}`, fetchOptions);
    const {
      error,
      client_secret: paymentIntentSecret,
      narvar_payment_id: narvarPaymentId,
      stripe_publishable_key: publishableKey,
      transaction_description: transactionDescription,
    } = await response.json();
    if (error) {
      throw new Error(error);
    }
    dispatch(
      receivePaymentResponse({
        service,
        paymentIntentSecret,
        narvarPaymentId,
        publishableKey,
        transactionDescription,
      }),
    );
    dispatch(receiveError(''));
  } catch (e) {
    dispatch(receiveError('Something went wrong'));
  }
};

export const receiveFee = (fee) => (dispatch) => {
  dispatch({
    type: RECEIVE_FEE,
    data: { fee },
  });
};

export const configureStripeWidget = (data) => (dispatch) => {
  dispatch({
    type: CONFIGURE_STRIPE_WIDGET,
    data,
  });
};
